/**
 * Shop by Category Component
 * 
 * Handles entrance animations for category items
 */

import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class ShopByCategory {
    constructor(container) {
        this.container = container;
        this.items = gsap.utils.toArray('.shop-by-category__item');
        this.sectionTitle = this.container.querySelector('.shop-by-category__section-title');

        this.init();
    }

    init = () => {
        // Animate section title if it exists
        if (this.sectionTitle) {
            const textLines = new SplitText(this.sectionTitle, { type: 'lines,words', linesClass: "lineParent" });
            
            gsap.fromTo(textLines.words, 
                { yPercent: 100 }, 
                {
                    yPercent: 0, 
                    duration: 0.6, 
                    stagger: { each: 0.1, ease: 'power.out', from: 'start' }, 
                    ease: 'power3.out', 
                    scrollTrigger: { trigger: this.container }
                }
            );
        }

        // Entrance animation for category items
        if (this.items.length > 0) {
            gsap.set(this.items, { opacity: 0, y: 40 });
            
            ScrollTrigger.batch(this.items, {
                interval: 0.1,
                batchMax: 4,
                start: "top 80%",
                onEnter: (elements) => {
                    gsap.to(elements, {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        stagger: 0.15,
                        ease: 'power2.out'
                    });
                }
            });
        }
    }
}

